/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Move_EarlierInputs */

const cs_pipelines_move_earlier = /** @type {(inputs: Pipelines_Move_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posunout dříve`)
};

const en_pipelines_move_earlier = /** @type {(inputs: Pipelines_Move_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move earlier`)
};

/**
* | output |
* | --- |
* | "Move earlier" |
*
* @param {Pipelines_Move_EarlierInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_move_earlier = /** @type {((inputs?: Pipelines_Move_EarlierInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Move_EarlierInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_move_earlier(inputs)
	return cs_pipelines_move_earlier(inputs)
});